// extracted by mini-css-extract-plugin
export default {"component":"SectionSeparator_component__4fMkU","darkMode":"SectionSeparator_darkMode__XJLlp"};